import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import { EVacancyStatus, IVacancy, IVacancyBody } from 'models/vacancies'
import { getNormalizedFormData } from 'shared/utils/getNormalizedFormData'

// existing_photos — массив строк: шлём одной JSON-строкой, иначе formData разложит поэлементно
const buildVacancyFormData = (data: Partial<IVacancyBody>) =>
  getNormalizedFormData({
    ...data,
    ...(data.existing_photos && { existing_photos: JSON.stringify(data.existing_photos) })
  })

export const vacanciesApi = {
  getVacancies: (): Promise<AxiosResponse<IVacancy[]>> => privateApi.get('/admin/vacancy'),
  createVacancy: (data: IVacancyBody) =>
    privateApi.post('/admin/vacancy', buildVacancyFormData(data), { timeout: 600000 }),
  updateVacancy: (id: string, data: Partial<IVacancyBody>) =>
    privateApi.patch(`/admin/vacancy/${id}`, buildVacancyFormData(data), { timeout: 600000 }),
  changeVacancyStatus: (id: string, status: EVacancyStatus) =>
    privateApi.patch(`/admin/vacancy/${id}`, getNormalizedFormData({ status })),
  deleteVacancy: (id: string) => privateApi.delete(`/admin/vacancy/${id}`)
}
